// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Int from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Int.js";
import * as SlabForm from "./SlabForm.bs.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";

function findSlab(slab_id, slabs) {
  var slab = List.find_opt((function (s) {
          return s.id === slab_id;
        }), slabs);
  if (slab !== undefined) {
    return slab;
  } else {
    return Curry._1(ErrorUtils$Catalyst.raiseError("SlabDetailsForm.re", "Slab not found L:78", undefined), undefined);
  }
}

function isStartDistanceValid(start_distance, end_distance) {
  return Belt_Option.mapWithDefault(start_distance, false, (function (v) {
                return v < Caml_format.caml_int_of_string(end_distance);
              }));
}

function updateExistingSlabs(existingSlabs, updateSlabs, slab_id, end_distance, price_per_min, price_per_km, isValid) {
  var updatedslab = findSlab(slab_id, existingSlabs);
  return Curry._1(updateSlabs, List.mapi((function (_index, slab) {
                    var match = slab.slab_no === updatedslab.slab_no;
                    if (match) {
                      return {
                              id: updatedslab.id,
                              slab_no: updatedslab.slab_no,
                              end_distance: end_distance,
                              price_per_min: price_per_min,
                              price_per_km: price_per_km,
                              isValid: isValid
                            };
                    } else {
                      return slab;
                    }
                  }), existingSlabs));
}

function removeSlab(existingSlabs, updateSlabs, slab_id, free_kms) {
  var removed_slab = findSlab(slab_id, existingSlabs);
  return Curry._1(updateSlabs, List.mapi((function (index, slab) {
                    if (index === removed_slab.slab_no) {
                      return {
                              id: slab.id,
                              slab_no: index,
                              end_distance: slab.end_distance,
                              price_per_min: slab.price_per_min,
                              price_per_km: slab.price_per_km,
                              isValid: isStartDistanceValid(index === 0 ? free_kms : Belt_Int.fromString(List.nth(existingSlabs, index - 1 | 0).end_distance), slab.end_distance)
                            };
                    } else {
                      return {
                              id: slab.id,
                              slab_no: index,
                              end_distance: slab.end_distance,
                              price_per_min: slab.price_per_min,
                              price_per_km: slab.price_per_km,
                              isValid: slab.isValid
                            };
                    }
                  }), List.filter(function (slab) {
                        return slab.id !== slab_id;
                      })(existingSlabs)));
}

function SlabList(Props) {
  var slabs = Props.slabs;
  var isSubmitted = Props.isSubmitted;
  var updateSlabs = Props.updateSlabs;
  var free_kms = Props.free_kms;
  return ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (index, slab) {
                    return React.createElement(React.Fragment, undefined, React.createElement(SlabForm.make, {
                                    slab_data: slab,
                                    isSubmitted: isSubmitted,
                                    onChange: (function (slab_id, end_distance, price_per_min, price_per_km, isValid) {
                                        return updateExistingSlabs(slabs, updateSlabs, slab_id, end_distance, price_per_min, price_per_km, isValid);
                                      }),
                                    removeSlab: (function (slab_id) {
                                        return removeSlab(slabs, updateSlabs, slab_id, free_kms);
                                      }),
                                    start_distance: index === 0 ? String(free_kms) : List.nth(slabs, index - 1 | 0).end_distance,
                                    key: slab.id
                                  }));
                  }), slabs));
}

var make = SlabList;

export {
  findSlab ,
  isStartDistanceValid ,
  updateExistingSlabs ,
  removeSlab ,
  make ,
  
}
/* react Not a pure module */
